import { PUBLIC_ENV_DEV_BOX_PREFIX } from "Utils/EnvironmentVars";

export const routerBaseName = PUBLIC_ENV_DEV_BOX_PREFIX;

export const hardRedirect = (path: string) => {
    window.location.href = new URL(routerBaseName + path, window.location.origin).href;
};
